export default {
    data() {
        return {
            valid: {
                card_number: false,
                store: true,
                mobile: false,
                country: false
            },
            success: {
                card_number: false,
                store: false,
                mobile: false,
                country: false
            },
            error: {
                card_number: "",
                store: "",
                mobile: "",
                country: ""
            },
            errorMessages: {
                cardNumberRequired: {
                    el: "Απαιτείται αριθμός κάρτας",
                    en: "Card Number is required",
                    it: "È richiesto il numero di carta"
                },
                cardCvcRequired: {
                    el: "Απαιτείται CVC της κάρτας και πρέπει να είναι ακριβώς 3 ψηφία",
                    en: "Card CVC is required and must be exactly 3 digits",
                    it: "Il CVC della carta è richiesto e deve essere esattamente di 3 cifre."
                },
                storeRequired: {
                    el: "Απαιτείται κατάστημα",
                    en: "Store is required",
                    it: "Il negozio è necessario"
                },
                mobileRequired: {
                    el: "Απαιτείται κινητό",
                    en: "Mobile is required",
                    it: "È richiesto il cellulare"
                },
                mobileLength: {
                    el: "Το κινητό χρήστη πρέπει να έχει μήκος μεταξύ 7 και 12 χαρακτήρων.",
                    en: "User Mobile must be between 7 and 12 characters long",
                    it: "Il cellulare dell'utente deve avere una lunghezza compresa tra 7 e 12 caratteri."
                },
                countryRequired: {
                    el: "Απαιτείται χώρα",
                    en: "Country is required",
                    it: "Il paese è richiesto"
                }
            }
        };
    },

    computed: {
        formValid() {
            return this.mode === 1
                ? 
                // this.valid.card_number && 
                this.valid.store && 
                this.valid.mobile &&
                this.valid.country
                : true;
        }
    },

    methods: {

        validateStore() {
            this.valid.store = false
            if(this.customerData.card_number && !this.customerData.store_id){
                this.error.store = this.errorMessages.storeRequired[
                    this.lang
                ];
            } else {
                this.error.store = "";
                this.valid.store = true
            }
        },

        validateMobile() {
            if (!this.customerData.mobile) {
                this.error.mobile = this.errorMessages.mobileRequired[
                    this.lang
                ];
            } else if (this.customerData.mobile.length < 7 ||  this.customerData.mobile.length > 12) {
                this.error.mobile = this.errorMessages.mobileLength[this.lang];
            } else {
                this.error.mobile = "";
                this.validateCountry();
            }
        },

        validateCountry() {
            if (!this.customerData.country_id) {
                this.error.country = this.errorMessages.countryRequired[
                    this.lang
                ];
            } else {
                this.error.country = "";
            }
        }
    },

    watch: {

        ["customerData.mobile"]: {
            immediate: true,
            handler(val) {    
                if (val) {
                    this.valid.mobile = (val.length >= 7 && val.length <= 12);
                    this.success.mobile = (val.length >= 7 && val.length <= 12);
                } else {
                    this.valid.mobile = false;
                    this.success.mobile = false;
                }
            }
        },

        ["customerData.country_id"]: {
            immediate: true,
            handler(val) {
                this.valid.country = !!val;
                this.success.country = !!val;
            }
        },

        resetSuccess(val) {
            if (val) {
                this.success = {
                    card_number: false,
                    store: false,
                    mobile: false,
                    country: false
                };

                this.setResetSuccess(false);
            }
        },

        resetValidation: {
            immediate: true,
            handler(val) {
                if (val) {
                    this.error = {
                        card_number: "",
                        store: "",
                        mobile: "",
                        country: ""
                    };

                    this.setResetValidation(false);
                }
            }
        }
    }
};
